/* eslint-disable prefer-destructuring */
/* eslint-disable no-shadow */

const state = {
	'query/tags': {
		search: '',
		type: ['category', 'brand', 'store', 'group', 'hashtag'],
		limit: 12,
		order: 'date',
	},
};

const getters = {
	'query/tags': state => state['query/tags'],
};

const mutations = {
	'TAGS/SET_QUERY_FILTER': function (state, filter) {
		state['query/tags'] = filter;
	},
	'TAGS/RESET_ALL_FILTERS': function (state) {
		state['query/tags'] = {
			search: '',
			type: null,
			limit: 12,
			order: 'date',
		};
	},
};

const actions = {
	'tags/list': async function ({ dispatch, commit, state, getters }, { reset = false }) {
		commit('SET_DATA_LOADING', { value: true, type: 'tags' });

		const query = state['query/tags'];

		let offset;
		if (reset) offset = 0; else offset = getters['data/tags'].results.length;

		let types;
		if (query.type.length > 0) { types = query.type.join(','); } else { types = 'category,brand,store,group,hashtag'; }

		const { data } = await this.$http.get('https://app.michollo.com/api/tags', { params: { type: types, show_image: 1, search: query.search, order_by: query.order, offset, limit: query.limit, show_metafooter: 1, show_description: 1 } });

		const result = {
			ok: false,
			state: 'complete',
			total: data.tags.total,
		};

		if (data.ok) {
			result.ok = true;

			dispatch('addData', { data: data.tags, type: 'tags', reset });

			if (offset < data.tags.total) result.state = 'loaded';
		}

		commit('SET_DATA_LOADING', { value: false, type: 'tags' });

		return result;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
